import request from '@/utils/request';

// CP游戏后台页面-获取下拉框数据
export function cpGameAdminSelect(data) {
  return request({
    url: '/admin/get_cp_game_admin_select',
    method: 'get',
    params: data,
  });
}
// CP游戏后台页面-列表
export function cpGameAdmin(data) {
  return request({
    url: '/admin/cp_game_admin',
    method: 'get',
    params: data,
  });
}
// CP游戏后台页面-添加
export function cpGameAdminAdd(data) {
  return request({
    url: '/admin/cp_game_admin',
    method: 'post',
    data,
  });
}
// CP游戏后台页面-修改(提交)
export function cpGameAdminEdit(data) {
  return request({
    url: `/admin/cp_game_admin/${data.id}`,
    method: 'put',
    data,
  });
}
// CP游戏后台页面-修改(提交)
export function cpGameAdminDel(id) {
  return request({
    url: `/admin/cp_game_admin/${id}`,
    method: 'delete',
  });
}
// CP游戏后台页面-修改(获取)
export function cpGameAdminEditInfo(id) {
  return request({
    url: `/admin/cp_game_admin/${id}`,
    method: 'get',
    params: {},
  });
}
// cp游戏后台-修改备注
export function getCpGameAdminLog(data) {
  return request({
    url: `/admin/get_cp_game_admin_log`,
    method: 'get',
    params: data,
  });
}
// cp游戏后台-修改备注
export function saveCpGameAdminRemark(data) {
  return request({
    url: `/admin/save_cp_game_admin_remark/${data.id}`,
    method: 'put',
    data,
  });
}

// 游戏运营对接-列表
export function gameManagement(data) {
  return request({
    url: `/admin/game_management`,
    method: 'get',
    params: data,
  });
}
// 游戏运营对接-获取下拉框
export function getGameManagementSelect(data) {
  return request({
    url: `/admin/get_game_management_select`,
    method: 'get',
    params: data,
  });
}
// 游戏运营对接-添加
export function gameManagementAdd(data) {
  return request({
    url: `/admin/game_management`,
    method: 'post',
    data,
  });
}
// 游戏运营对接-修改(详情)
export function gameManagementEditInfo(id) {
  return request({
    url: `/admin/game_management/${id}`,
    method: 'get',
    params: {},
  });
}
// 游戏运营对接-修改(修改)
export function gameManagementEdit(data) {
  return request({
    url: `/admin/game_management/${data.id}`,
    method: 'put',
    data,
  });
}
// 游戏运营对接-修改备注
export function saveGameManagementRemark(data) {
  return request({
    url: `/admin/game_management/${data.id}`,
    method: 'put',
    data,
  });
}
// 游戏运营对接-删除
export function gameManagementDel(id) {
  return request({
    url: `/admin/game_management/${id}`,
    method: 'delete',
  });
}

// 游戏现状态-类型列表
export function gameManagementType(data) {
  return request({
    url: `/admin/game_management_type`,
    method: 'get',
    params: data,
  });
}
// 游戏现状态-类型添加
export function gameManagementTypeAdd(data) {
  return request({
    url: `/admin/game_management_type`,
    method: 'post',
    data,
  });
}
// 游戏现状态-类型修改
export function gameManagementTypeEdit(data) {
  return request({
    url: `/admin/game_management_type/${data.id}`,
    method: 'put',
    data,
  });
}
// 游戏现状态-类型删除
export function gameManagementTypeDel(id) {
  return request({
    url: `/admin/game_management_type/${id}`,
    method: 'delete',
  });
}
// 评价类型列表
export function getEvaluationTypeList(params) {
  return request({
    url: '/admin/vip_evaluation_type',
    method: 'get',
    params: params,
  });
}
// 评价类型新增
export function addEvaluationType(data) {
  return request({
    url: '/admin/vip_evaluation_type',
    method: 'post',
    data: data,
  });
}
// 评价类型修改
export function editEvaluationType(data) {
  return request({
    url: `/admin/vip_evaluation_type/${data.id}`,
    method: 'put',
    data: data,
  });
}
// 评价类型删除
export function delEvaluationType(id) {
  return request({
    url: `/admin/vip_evaluation_type/${id}`,
    method: 'delete',
  });
}
